import {createAction, props} from "@ngrx/store";
import {
    IAddPlaybookDTO,
    IGetPlaybookCategoriesDto,
    IGetPlaybooksListingDto,
    IPlaybookCategoryDTO,
    IPlaybooksItemDTO,
    IUpdateGuidelineDTO,
    IUpdatePlaybookGuidelineDTO
} from "../dto/playbooks-listening.dto";
import {
    IPlaybookDefaultFilter
} from "../legal-hub-playbooks-listening/legal-hub-basic-filters/legal-hub-basic-filters.component";
 
import {LegalHubPlaybooksListingFeatureKey} from "./playbooks.config";

const scope = `[${LegalHubPlaybooksListingFeatureKey}]`;

export const resetState = createAction(`${scope} Reset state`);
export const fetchPlaybooks = createAction(`${scope} fetch playbooks`);
export const fetchPlaybooksSucceeded = createAction(`${scope} Fetch playbooks Succeeded`, (playbooksList: IGetPlaybooksListingDto) => ({playbooksList: playbooksList}));
export const fetchPlaybooksFailed = createAction(`${scope} Fetch playbooks Failed`, (error: string) => ({error}));

export const searchChange = createAction(`${scope} Search value changed`, (searchValue: string) => ({searchValue}));
export const defaultFilterChanged = createAction(`${scope} default filters changed`, (filters: IPlaybookDefaultFilter) => ({filters}));
export const changePage = createAction(`${scope} Change Page`, (pageNumber: number) => ({pageNumber}));


export const fetchCategories = createAction(`${scope} fetch categories`, props<{search?: string}>());
export const fetchCategoriesSucceeded = createAction(`${scope} Fetch categories Succeeded`, (categories: IGetPlaybookCategoriesDto) => ({categories: categories}));
export const fetchCategoriesFailed = createAction(`${scope} Fetch categories Failed`, (error: string) => ({error}));

export const addNewCategory = createAction(`${scope} add new category`, (categoryName: string) => ({categoryName: categoryName}));
export const addNewCategorySucceeded = createAction(`${scope} add new category Succeeded`, (category: IPlaybookCategoryDTO) => ({category: category}));
export const addNewCategoryFailed = createAction(`${scope} add new category Failed`, (error: string) => ({error}));

export const addNewPlaybook = createAction(`${scope} add new playbook`, (newPlaybook:IAddPlaybookDTO) => ({newPlaybook: newPlaybook}));
export const addNewPlaybookSucceeded = createAction(`${scope} add new playbook Succeeded`, (playbooksItem: IPlaybooksItemDTO) => ({playbooksItem: playbooksItem}));
export const addNewPlaybookFailed = createAction(`${scope} add new playbook Failed`, (error: string) => ({error}));

export const editPlaybookClicked = createAction(`${scope} Edit Playbook Clicked`, props<{playbook: IPlaybooksItemDTO}>());
export const addNewPlaybookClicked = createAction(`${scope} Add New Playbook Clicked`);

export const updatePlaybook = createAction(`${scope} update playbook`, ( id:number, playbook:IUpdatePlaybookGuidelineDTO) => ({id:id, playbook: playbook}));
export const updatePlaybookSucceeded = createAction(`${scope} update playbook Succeeded`, (playbooksItem: IPlaybooksItemDTO) => ({playbooksItem: playbooksItem}));
export const updatePlaybookFailed = createAction(`${scope} update playbook Failed`, (error: string) => ({error}));

export const updateGuideline = createAction(`${scope} update Guideline`, ( id:number, guideline:IUpdateGuidelineDTO) => ({id:id, guideline: guideline}));
export const updateGuidelineSucceeded = createAction(`${scope} update Guideline Succeeded`, (playbooksItem: IPlaybooksItemDTO[],  playbookId: number) => ({playbooksItem: playbooksItem, playbookId: playbookId}));
export const updateGuidelineFailed = createAction(`${scope} update Guideline Failed`, (error: string) => ({error}));
export const viewDestroyed = createAction(`${scope} View Destroyed`);

 export const deletePlaybook = createAction('Delete Playbook', (playbookId: number) => ({playbookId}));
 export const deletePlaybookSuccess = createAction('Delete Playbook Success', (playbookId: number) => ({playbookId}));
 export const deletePlaybookFailure = createAction('Delete Playbook Failure', (error: string) => ({error}));